module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Qty"
    },
    on: {
      "input": _vm.handleInput
    },
    model: {
      value: (_vm.content.quantity),
      callback: function($$v) {
        _vm.$set(_vm.content, "quantity", $$v)
      },
      expression: "content.quantity"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.periods,
      "label": "Select Period"
    },
    on: {
      "input": _vm.handleInput
    },
    model: {
      value: (_vm.content.period),
      callback: function($$v) {
        _vm.$set(_vm.content, "period", $$v)
      },
      expression: "content.period"
    }
  })], 1)], 1)
},staticRenderFns: []}